import { normalizeNode } from "./normalizeNode.js";
export function withListsNormalization(editor) {
  const parent = {
    normalizeNode: editor.normalizeNode
  };
  editor.normalizeNode = (entry, options) => {
    return normalizeNode(editor, entry) || parent.normalizeNode(entry, options);
  };
  return editor;
}